import { axios } from 'shared/services/axios'

export function setSessionCookies(boardId) {
  return axios.post(`/live_board/v1/boards/${boardId}/session_cookies`)
  .then(response => response.data)
}